import React, { useMemo, useState } from 'react';
import { Divider, Tab, Tabs } from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth, hasModuleAccess } from '@panna/auth';
import DiceJobsContext from 'src/context/dice/diceJobsContext';
import { DiceJobsContextType } from 'src/context/types';
import { Module } from '../access';

function DiceTabs() {
  const location = useLocation();
  const authContext = useAuth();

  const [diceSearch, setDiceSearch] = useState<DiceJobsContextType['diceSearch']>(null);

  const jobContextValue = useMemo(() => ({
    diceSearch,
    setDiceSearch,
  }), [diceSearch]);

  const tabs = [
    {
      label: 'Search',
      module: Module.DICE_SEARCH,
      to: '/dice/search',
    },
    {
      label: 'Jobs',
      to: '/dice/jobs',
      module: Module.DICE_JOBS,
    },
    {
      label: 'Dashboard',
      to: '/dice/dashboard',
      module: Module.DICE_DASHBOARD,
    },
    {
      label: 'History',
      to: '/dice/history',
      module: Module.DICE_HISTORY,
    },
  ];

  const filteredTabs = tabs.filter((tab) => {
    if (tab.module) {
      return hasModuleAccess(authContext?.authState?.userInfo?.modules || [], tab.module);
    }
    return true;
  });

  return (
    <DiceJobsContext.Provider value={jobContextValue}>
      <div className="w-full bg-white">
        <Tabs
          value={filteredTabs.findIndex((tab) => location.pathname.startsWith(tab.to))}
          className="pl-8"
        >
          {filteredTabs.map((tab) => (
            <Tab
              key={tab.to}
              label={tab.label}
              component={Link}
              to={tab.to}
              sx={{
                padding: '1px 12px',
                minWidth: '8rem',
              }}
            />
          ))}
        </Tabs>
        <Divider className="pl-8" />
        <Outlet />
      </div>
    </DiceJobsContext.Provider>
  );
}

export default DiceTabs;
